import { z } from 'zod';
import { SLUG_MAX_LENGTH, SLUG_MIN_LENGTH, SLUG_PATTERN, SLUG_PATTERN_MESSAGE, } from './policies/slug.js';
export const slugSchema = z
    .string()
    .min(SLUG_MIN_LENGTH)
    .max(SLUG_MAX_LENGTH)
    .regex(SLUG_PATTERN, SLUG_PATTERN_MESSAGE);
//# sourceMappingURL=slug.js.map